import React, { useState } from 'react'
import t from '../../translations/i18n'
import '../../scss/rastrear-pedido.scss'

export default function RastrearPedido() {
  const [trackingNumber, setTrackingNumber] = useState('')

  const handleTrackOrder = (e) => {
    e.preventDefault()

    if (trackingNumber) {
      window.location.href = global.ORDERCRASTREO + '?orden=' + trackingNumber
    } else {
      alert('Por favor ingrese un número de orden.')
    }
  }

  return (
    <div className="page-content easybuy-tracking-page">
      <div className="container">
        <div className="easybuy-tracking-header text-center">
          <span className="easybuy-tracking-badge">
            <i className="la la-map-marker"></i>
            Seguimiento
          </span>

          <h2>{t('rastreo.tittle')}</h2>

          <p>{t('rastreo.p_1')}</p>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-9 col-lg-7">
            <div className="easybuy-tracking-card">
              <div className="easybuy-tracking-icon">
                <i className="la la-truck"></i>
              </div>

              <h3>{t('rastreo.p_2')}</h3>

              <p className="easybuy-tracking-description">
                Ingresa el número de tu orden para consultar su estado.
              </p>

              <form
                onSubmit={handleTrackOrder}
                className="easybuy-tracking-form"
              >
                <label
                  htmlFor="tracking-number"
                  className="easybuy-tracking-label"
                >
                  {t('rastreo.p_2')}
                </label>

                <input
                  type="text"
                  className="form-control"
                  id="tracking-number"
                  value={trackingNumber}
                  onChange={(e) => setTrackingNumber(e.target.value)}
                  placeholder={t('rastreo.p_2')}
                  required
                />

                <button type="submit" className="easybuy-tracking-button">
                  <span>{t('rastreo.p_3')}</span>
                  <i className="icon-long-arrow-right"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
